import { EmailContentType, EmailEntryPoint, Emptyable } from "@simplyk/common";

import { EmailContentLinkedFormType } from "@/components/EmailEditor/types";
import { EmailContentBuilderType } from "@/components/EmailEditor/useGetEmailContent";

export const hasCampaignContext = (formId: Emptyable<string>): boolean => Boolean(formId);

const getOccurrenceScope = (
  emailContent: EmailContentBuilderType,
  linkedForm?: EmailContentLinkedFormType
): "all_dates" | "single_date" | null => {
  if (emailContent.emailType !== EmailContentType.BLAST) {
    return null;
  }
  if (!linkedForm?.targetedOccurrenceDate) {
    return "all_dates";
  }
  return "single_date";
};

export const END_OF_YEAR_CHECKLIST_OPENED_FROM = "EndOfYearChecklist" as const;

export type EndOfYearChecklistEmailType = "lapsed_donor" | "last_chance";

const END_OF_YEAR_CHECKLIST_EMAIL_TYPES: Partial<Record<EmailEntryPoint, EndOfYearChecklistEmailType>> = {
  [EmailEntryPoint.EndOfYearChecklistLapsedDonor]: "lapsed_donor",
  [EmailEntryPoint.EndOfYearChecklistLastChance]: "last_chance",
};

export const getEmailingAmplitudeParams = (
  emailContent: EmailContentBuilderType,
  linkedForm?: EmailContentLinkedFormType
) => {
  const endOfYearChecklistEmailType = emailContent.entryPoint
    ? END_OF_YEAR_CHECKLIST_EMAIL_TYPES[emailContent.entryPoint]
    : undefined;
  const openedFrom = endOfYearChecklistEmailType
    ? END_OF_YEAR_CHECKLIST_OPENED_FROM
    : (emailContent.entryPoint ?? emailContent.openedFrom);
  return {
    openedFrom,
    pathname: openedFrom,
    emailType: endOfYearChecklistEmailType ?? emailContent.emailType,
    flow: emailContent.flow,
    occurrence_scope: getOccurrenceScope(emailContent, linkedForm),
  };
};
